import {OrderApi} from '../request/Order/order_api'
import store from '../store'
import {CommonApi} from '../request/common_api'

function dishTypeList (isUpdate = false) {
  // 菜品类型下拉框
  if (store.state.order.dishTypeList.length && isUpdate) {
    return
  }
  OrderApi.queryOrderDropDown('001', {})
    .then(res => {
      if (res.retCode === '0000') {
        store.commit('order/setDishTypeList', res.BizBodyMsg.codeList)
      }
    })
}

function mealPackageTypeSorts () {
  // 套餐类型下拉框
  if (store.state.order.mealPackageTypeSorts.length) {
    return
  }
  CommonApi.getTableList('MEALPACKAGETYPE').then(res => {
    if (res.retCode === '0000') {
      store.commit('order/setMealPackageTypeSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function takeMealStatusSorts () {
  // 取餐状态下拉框
  if (store.state.order.mealPackageTypeSorts.length) {
    return
  }
  CommonApi.getTableList('TAKEMEALSTU').then(res => {
    if (res.retCode === '0000') {
      store.commit('order/setTakeMealStatusSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function dishesDropDownList (merchid = '', dishtype = '') {
  // 菜品列表下拉框
  OrderApi.queryOrderDropDown('002', {merchid: merchid, dishtype: dishtype}).then(res => {
    if (res.retCode === '0000') {
      store.commit('order/setDishesList', res.BizBodyMsg.codeList)
    }
  })
}

function mealPackageDropDownList (merchid = '', mptype = '') {
  // 套餐列表下拉框
  // if (store.state.merchantList.length) {
  //   return
  // }
  OrderApi.queryOrderDropDown('003', {merchid: merchid, mptype: mptype}).then(res => {
    if (res.retCode === '0000') {
      store.commit('order/setMealPackageDropDownList', res.BizBodyMsg.codeList)
    }
  })
}

function validPackageList (data) {
  // 有效套餐列表
  OrderApi.queryOrderDropDown('006', data).then(res => {
    if (res.retCode === '0000') {
      store.commit('order/setValidPackageList', res.BizBodyMsg.codeList)
    }
  })
}

const getOrderDropDownList = {dishTypeList, mealPackageTypeSorts, mealPackageDropDownList, validPackageList, takeMealStatusSorts, dishesDropDownList}

export {getOrderDropDownList}



// WEBPACK FOOTER //
// ./src/util/OrderDropDownList.js